import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import React from 'react';
const MainDiv = styled.div`
  max-width: 220px;
  transition: opacity 0.4s linear;
`;
const ArrowLabel = styled(Typography, {
  shouldForwardProp: prop => prop !== 'customColor',
})<{ customColor: string }>`
  margin: 0 0 0 0;
  font-family: var(--font-work-sans), sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 136.8%;
  display: inline-block;
  align-items: flex-end;
  width: 220px;
  color: ${props => props.customColor};
  :hover {
    cursor: pointer;
  }
`;
const Blob = styled.img`
  width: 80%;
  height: auto;
`;
const Arrow = styled.svg`
  min-height: 20px;
  min-width: 20px;
  margin-left: 5px;
  margin-bottom: -5px;
`;
export type GalaxyProps = {
  labelColor?: string;
  label?: string;
  vector?: string;
  opacity?: number;
};

const HostBlob = ({ label, labelColor, vector, opacity }: GalaxyProps) => {
  return (
    <MainDiv style={{ opacity: opacity }}>
      <Blob src={vector} alt="" />

      <ArrowLabel customColor={labelColor!}>
        {label}
        <Arrow
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0605 -4.3976e-07C15.6168 -6.82633e-07 20.1211 4.50426 20.1211 10.0605C20.1211 15.6168 15.6168 20.1211 10.0605 20.1211C4.50426 20.1211 -1.96887e-07 15.6168 -4.3976e-07 10.0605C-6.82633e-07 4.50426 4.50426 -1.96887e-07 10.0605 -4.3976e-07Z"
            fill={labelColor}
          />
          <path
            d="M8.88379 14.462L13.2853 10.0611L8.88379 5.65964"
            stroke="white"
            strokeWidth="1.77539"
            strokeLinecap="round"
          />
        </Arrow>
      </ArrowLabel>
    </MainDiv>
  );
};

export default HostBlob;
